module.exports = __webpack_public_path__ + "img/border3.ed640c8b.png";